"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

define('viewModels/fourFive/fourFiveUserCallbackViewModel',["require", "exports", "knockout", "moment"], function (require, exports, ko, moment) {
    "use strict";

    var FourFiveUserCallbackViewModel = function () {
        function FourFiveUserCallbackViewModel(fourFiveUserCommunication) {
            _classCallCheck(this, FourFiveUserCallbackViewModel);

            this.callbackRequestedDateTime = ko.observable('');
            this.callbackDateTime = ko.observable('');
            this.telephone = ko.observable('');
            this.isSterling = ko.observable(false);
            this.requestUuid = ko.observable('');
            this.submitted = ko.observable('');
            this.externalUuid = ko.observable('');
            this.requesterIp = ko.observable('');
            this.success = ko.observable(false);
            this.error = ko.observable('');
            this.requestStatusCode = ko.observable('');
            this.appId = ko.observable('');
            this.userId = ko.observable('');
            this.source = ko.observable('');
            this.externalReferer = ko.observable('');
            this.internalReferer = ko.observable('');
            this.update(fourFiveUserCommunication);
        }

        _createClass(FourFiveUserCallbackViewModel, [{
            key: "update",
            value: function update(fourFiveUserCommunication) {
                this.callbackRequestedDateTime(fourFiveUserCommunication.callbackRequestedDateTime ? moment(fourFiveUserCommunication.callbackRequestedDateTime).format('DD/MM/YYYY HH:mm:ss') : '');
                this.callbackDateTime(fourFiveUserCommunication.callbackDateTime ? moment(fourFiveUserCommunication.callbackDateTime).format('DD/MM/YYYY HH:mm:ss') : '');
                this.telephone(fourFiveUserCommunication.telephone);
                this.isSterling(fourFiveUserCommunication.isSterling);
                this.requestUuid(fourFiveUserCommunication.requestUuid);
                this.submitted(fourFiveUserCommunication.submitted ? moment(fourFiveUserCommunication.submitted).format('DD/MM/YYYY HH:mm:ss') : '');
                this.externalUuid(fourFiveUserCommunication.externalUuid);
                this.requesterIp(fourFiveUserCommunication.requesterIp);
                this.success(fourFiveUserCommunication.success);
                this.error(fourFiveUserCommunication.error);
                this.requestStatusCode(fourFiveUserCommunication.requestStatusCode);
                this.appId(fourFiveUserCommunication.appId);
                this.userId(fourFiveUserCommunication.userId);
                this.source(fourFiveUserCommunication.source);
                this.externalReferer(fourFiveUserCommunication.externalReferer);
                this.internalReferer(fourFiveUserCommunication.internalReferer);
            }
        }, {
            key: "clear",
            value: function clear() {
                this.callbackRequestedDateTime('');
                this.callbackDateTime('');
                this.telephone('');
                this.isSterling(false);
                this.requestUuid('');
                this.submitted('');
                this.externalUuid('');
                this.requesterIp('');
                this.success(false);
                this.error('');
                this.requestStatusCode('');
                this.appId('');
                this.userId('');
                this.source('');
                this.externalReferer('');
                this.internalReferer('');
            }
        }]);

        return FourFiveUserCallbackViewModel;
    }();

    return FourFiveUserCallbackViewModel;
});
//# sourceMappingURL=fourFiveUserCallbackViewModel.js.map;
